import { IntegrationsService } from './integration.service';
import { interval } from 'rxjs';
import { distinctUntilKeyChanged, flatMap, takeWhile } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "./integration.service";
var IntegrationStatePollingService = /** @class */ (function () {
    function IntegrationStatePollingService(integrationService) {
        this.integrationService = integrationService;
        this.POLLING_INTERVAL_MILLIS = 1000 * 3;
        this.pollingActive = false;
    }
    IntegrationStatePollingService.prototype.pollIntegrationState = function (type) {
        var _this = this;
        this.pollingActive = true;
        return interval(this.POLLING_INTERVAL_MILLIS).pipe(takeWhile(function () { return _this.pollingActive; }), flatMap(function () { return _this.integrationService.checkIntegrationStatus(type); }), distinctUntilKeyChanged('integrated'));
    };
    IntegrationStatePollingService.prototype.stopPolling = function () {
        this.pollingActive = false;
    };
    IntegrationStatePollingService.ngInjectableDef = i0.defineInjectable({ factory: function IntegrationStatePollingService_Factory() { return new IntegrationStatePollingService(i0.inject(i1.IntegrationsService)); }, token: IntegrationStatePollingService, providedIn: "root" });
    return IntegrationStatePollingService;
}());
export { IntegrationStatePollingService };
